import { Role } from './enums/role.enum';
import { Color } from './enums/color.enum';

export class JwtUser {
  jti: number;
  name: string;
  role: Role;
  color: Color;
  reportsAccess: boolean;
  viewCardTransactions: boolean;
  viewCardSettings: boolean;
  editCardsAccess: boolean;
  newCardRequestAccess: boolean;
  viewCardHistory: boolean;
  customerNoGroup: string;
  cardSettingColumns: string;
  cardRequestColumns: string;
  cardTransactionColumns: string;
  exp: number;
  iss: string;
  aud: string;

  constructor(jwtUser: any = {}) {
    this.jti = jwtUser.jti;
    this.name = jwtUser.name || '';
    this.role = jwtUser.role;
    this.color = jwtUser.color || Color.RED;
    this.reportsAccess = jwtUser.reportsAccess || false;
    this.viewCardTransactions = jwtUser.viewCardTransactions || false;
    this.viewCardSettings = jwtUser.viewCardSettings || false;
    this.editCardsAccess = jwtUser.editCardsAccess || false;
    this.newCardRequestAccess = jwtUser.newCardRequestAccess || false;
    this.viewCardHistory = jwtUser.viewCardHistory || false;
    this.customerNoGroup = jwtUser.customerNoGroup;
    this.cardSettingColumns = jwtUser.cardSettingColumns || '';
    this.cardRequestColumns = jwtUser.cardRequestColumns || '';
    this.cardTransactionColumns = jwtUser.cardTransactionColumns || '';
    this.exp = jwtUser.exp || 0;
    this.iss = jwtUser.iss || '';
    this.aud = jwtUser.aud || '';
  }
}
